import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Box,
  Grid,
  Avatar,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Chip,
  IconButton,
  InputBase,
  Link,
} from "@mui/material";
import {
  Visibility,
  Code,
  Search,
  Close,
  ArrowUpward,
} from "@mui/icons-material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useTheme } from "@mui/material/styles";
import FullWidthContent from "../components/FullWidthContent";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

import jsIcon from "../assets/icons/js.png";
import reactIcon from "../assets/icons/react.png";
import pythonIcon from "../assets/icons/python.png";
import htmlIcon from "../assets/icons/html.png";
import cssIcon from "../assets/icons/css.png";
import gcpIcon from "../assets/icons/gcp.png";
import firebaseIcon from "../assets/icons/firebase.png";
import tsIcon from "../assets/icons/ts.png";
import nodeIcon from "../assets/icons/nodejs.png";
import mongodbIcon from "../assets/icons/mongodb.png";

function Home() {
  const theme = useTheme();
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-in-out",
    });

    const handleScroll = () => {
      const projectsSection = document.getElementById("projects");
      if (projectsSection) {
        const rect = projectsSection.getBoundingClientRect();
        setShowScrollButton(window.scrollY > rect.top);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScrollToProjects = (e) => {
    e.preventDefault();
    const projectsSection = document.getElementById("projects");
    if (projectsSection) {
      projectsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const skills = [
    { name: "JavaScript", icon: jsIcon },
    { name: "TypeScript", icon: tsIcon },
    { name: "React", icon: reactIcon },
    { name: "Node.js", icon: nodeIcon },
    { name: "Python", icon: pythonIcon },
    { name: "HTML", icon: htmlIcon },
    { name: "CSS", icon: cssIcon },
    { name: "GCP", icon: gcpIcon },
    { name: "Firebase", icon: firebaseIcon },
    { name: "MongoDB", icon: mongodbIcon },
  ];

  const projectsData = [
    {
      id: 1,
      translationKey: "project7",
      technologies: ["JavaScript", "React", "Python", "FastAPI", "GCP", "CI/CD", "HTML", "CSS", "Front End", "Back End", "Cloud"],
      links: {
        
      }
    },
    {
      id: 2,
      translationKey: "project8",
      technologies: ["JavaScript", "React Native", "Vue.js", "Node.js", "GraphQL", "API", "FinTech", "Back End"],
      links: {

      }
    },
    {
      id: 3,
      translationKey: "project11",
      image: "/images/studio.png",
      technologies: ["JavaScript", "TypeScript", "React", "Electron"],
      links: {
        demo: "https://pokemonworkshop.com/fr/studio",
        code: "https://github.com/PokemonWorkshop/PokemonStudio"
      }
    },
    {
      id: 4,
      translationKey: "project9",
      image: "/images/fumblebot.png",
      technologies: ["JavaScript", "Node.js", "Discord.js", "MongoDB", "Bot", "React", "HTML", "CSS", "Scraping", "Front End", "Back End"],
      links: {
        demo: "https://fumblebot.netlify.app",
        code: "https://github.com/GaburaisuVGC/fumble_bot_reloaded",
      },
    },
    {
      id: 5,
      translationKey: "project10",
      image: "/images/loire.png",
      technologies: ["JavaScript", "React", "Firebase", "API", "HTML", "CSS", "Front End"],
      links: {
        demo: "https://loireetnatureconciergerie.fr",
        code: "https://github.com/GaburaisuVGC/loire-et-nature-conciergerie",
      },
    },
    {
      id: 6,
      translationKey: "project1",
      image: "/images/thedaringtype.jpg",
      technologies: ["JavaScript", "React", "HTML", "CSS", "Front End"],
      links: {
        demo: "https://thedaringtype.com",
        code: "https://github.com/GaburaisuVGC/thedaringtype",
      },
    },
    {
      id: 7,
      translationKey: "project2",
      image: "/images/jbj.jpg",
      technologies: ["JavaScript", "React", "HTML", "CSS", "Front End"],
      links: {
        demo: "https://jocelynejeanbaptiste.fr",
      },
    },
    {
      id: 8,
      translationKey: "project3",
      image: "/images/matchups.jpg",
      technologies: [
        "JavaScript",
        "React",
        "Node.js",
        "Express",
        "AWS",
        "Scrapping",
        "API",
        "JSON",
        "Front End",
        "Back End",
        "Full Stack",
      ],
      links: {
        demo: "https://matchups.net",
        code: "https://github.com/GaburaisuVGC/matchups",
      },
    },
    {
      id: 9,
      translationKey: "project5",
      technologies: [
        "JavaScript",
        "Node.JS",
        "MongoDB",
        "Discord.js",
        "Bot",
        "Back End",
      ],
      links: {
        code: "https://github.com/GaburaisuVGC/kremaldygames",
      },
    },
    {
      id: 10,
      translationKey: "project6",
      technologies: [
        "JavaScript",
        "React",
        "Node.JS",
        "Express",
        "MongoDB",
        "MERN",
        "API",
        "Scraping",
        "GCP",
        "Docker",
        "Front End",
        "Back End",
        "Full Stack",
      ],
      links: {
        code: "https://github.com/GaburaisuVGC/vgc-hub",
      },
    },
  ];

  const handleTagClick = (tag) => {
    if (!selectedTags.includes(tag)) {
      setSelectedTags([...selectedTags, tag]);
    }
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 10);
  };

  const handleTagDelete = (tagToDelete) => {
    setSelectedTags(selectedTags.filter((tag) => tag !== tagToDelete));
  };

  const handleTextChange = (e) => {
    setSearchText(e.target.value);
  };

  useEffect(() => {
    const allSearchTerms = [...selectedTags, searchText.toLowerCase()];

    if (allSearchTerms.length === 0) {
      setFilteredProjects(projectsData);
      return;
    }

    const filtered = projectsData.filter((project) => {
      const projectTrans = t(`projects.${project.translationKey}`, {
        returnObjects: true,
        defaultValue: {
          title: `Project ${project.id}`,
          description: "No description available",
        },
      });

      const projectText =
        projectTrans.title.toLowerCase() +
        " " +
        projectTrans.description.toLowerCase() +
        " " +
        project.technologies.join(" ").toLowerCase();

      return allSearchTerms.every((term) =>
        projectText.includes(term.toLowerCase())
      );
    });

    setFilteredProjects(filtered);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, selectedTags, t]);

  return (
    <>
      <Navbar showLanguageSelector={true} showThemeSwitch={false} />

      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          px: 2,
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          data-aos="fade-down"
          sx={{
            fontWeight: 700,
            mb: 2,
            fontSize: { xs: "2.5rem", md: "4rem" },
          }}
        >
          {t("home_title")}
        </Typography>

        <Typography
          variant="h5"
          component="p"
          data-aos="fade-down"
          data-aos-delay="100"
          sx={{
            maxWidth: "800px",
            mb: 4,
            fontSize: { xs: "1.2rem", md: "1.5rem" },
          }}
        >
          {t("home_description")}
        </Typography>

        <Box data-aos="fade-up" data-aos-delay="200">
          <IconButton
            onClick={handleScrollToProjects}
            sx={{
              fontSize: "1.5rem",
              animation: "bounce 2s infinite",
              "@keyframes bounce": {
                "0%, 100%": { transform: "translateY(0)" },
                "50%": { transform: "translateY(-10px)" },
              },
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            ↓
          </IconButton>
        </Box>
      </Box>

      {/* Bouton Scroll to Top */}
      <Box
        sx={{
          position: "fixed",
          bottom: 32,
          right: 32,
          width: 56,
          height: 56,
          padding: "4px",
          background:
            "linear-gradient(45deg, #ff00cc, #333399, #00ccff, #00ff99)",
          backgroundSize: "300% 300%",
          borderRadius: "16px",
          boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
          zIndex: 1000,
          opacity: showScrollButton ? 1 : 0,
          transform: showScrollButton ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 0.3s ease, transform 0.3s ease",
          "&:hover": {
            transform: showScrollButton
              ? "translateY(-5px)"
              : "translateY(15px)",
            animation: "animatedGradient 3s ease infinite",
          },
          "@keyframes animatedGradient": {
            "0%": { backgroundPosition: "0% 50%" },
            "50%": { backgroundPosition: "100% 50%" },
            "100%": { backgroundPosition: "0% 50%" },
          },
        }}
      >
        <IconButton
          onClick={scrollToTop}
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "12px",
            background:
              theme.palette.mode === "dark"
                ? "rgba(30, 30, 30, 0.9)"
                : "rgba(255, 255, 255, 0.9)",
            transition: "background 0.3s",
            "&:hover": {
              background:
                theme.palette.mode === "dark"
                  ? "rgba(30, 30, 30, 0.95)"
                  : "rgba(255, 255, 255, 0.95)",
            },
          }}
          aria-label="Retour en haut"
        >
          <ArrowUpward
            sx={{
              color: theme.palette.text.primary,
              transition: "transform 0.3s",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </IconButton>
      </Box>

      {/* Section Projets */}
      <Container id="projects" maxWidth="lg" sx={{ py: 14 }}>
        <Typography
          variant="h3"
          component="h2"
          align="center"
          data-aos="fade-up"
          sx={{
            fontWeight: 700,
            mb: 4,
            fontSize: { xs: "2rem", md: "2.5rem" },
            color: theme.palette.text.primary,
          }}
        >
          {t("experiences")}
        </Typography>

        {/* Barre de recherche et filtre */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 8,
            px: 2,
          }}
          data-aos="fade-up"
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "600px",
              border: "1px solid",
              borderColor:
                theme.palette.mode === "dark"
                  ? "rgba(255, 255, 255, 0.23)"
                  : "rgba(0, 0, 0, 0.23)",
              borderRadius: "50px",
              padding: "8px 16px",
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "8px",
              "&:hover": {
                borderColor: theme.palette.text.primary,
              },
              "&:focus-within": {
                borderColor: theme.palette.primary.main,
                borderWidth: "2px",
              },
            }}
          >
            {/* Tags sélectionnés */}
            {selectedTags.map((tag, index) => (
              <Chip
                key={index}
                label={tag}
                onDelete={() => handleTagDelete(tag)}
                deleteIcon={<Close />}
                sx={{
                  backgroundColor:
                    theme.palette.mode === "dark"
                      ? theme.palette.primary.dark
                      : theme.palette.primary.light,
                  color: theme.palette.getContrastText(
                    theme.palette.mode === "dark"
                      ? theme.palette.primary.dark
                      : theme.palette.primary.light
                  ),
                }}
              />
            ))}

            {/* Champ de recherche */}
            <InputBase
              inputRef={inputRef}
              placeholder={
                selectedTags.length === 0 ? t("search_placeholder") : ""
              }
              value={searchText}
              onChange={handleTextChange}
              sx={{
                flexGrow: 1,
                ml: 1,
                color: theme.palette.text.primary,
              }}
              startAdornment={
                selectedTags.length === 0 && (
                  <Search sx={{ color: theme.palette.text.secondary, mr: 1 }} />
                )
              }
            />
          </Box>
        </Box>

        <Grid container spacing={4}>
          {filteredProjects.map((project) => {
            const projectTrans = t(`projects.${project.translationKey}`, {
              returnObjects: true,
              defaultValue: {
                title: `Project ${project.id}`,
                description: "No description available",
              },
            });
            const projectLink = project.links.demo || project.links.code;

            return (
              <Grid
                item
                xs={12}
                md={6}
                key={project.id}
                data-aos="fade-up"
                sx={{ display: "flex" }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    padding: "4px",
                    background:
                      "linear-gradient(45deg, #ff00cc, #333399, #00ccff, #00ff99)",
                    backgroundSize: "300% 300%",
                    borderRadius: "20px",
                    transition:
                      "background-position 0.6s ease, transform 0.3s ease",
                    boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 12px 20px rgba(0,0,0,0.15)",
                      backgroundPosition: "100% 50%",
                    },
                    "@keyframes animatedGradient": {
                      "0%": { backgroundPosition: "0% 50%" },
                      "50%": { backgroundPosition: "100% 50%" },
                      "100%": { backgroundPosition: "0% 50%" },
                    },
                    // eslint-disable-next-line no-dupe-keys
                    "&:hover": {
                      animation: "animatedGradient 3s ease infinite",
                    },
                  }}
                >
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "16px",
                      boxShadow: "none",
                      background:
                        theme.palette.mode === "dark"
                          ? "rgba(30, 30, 30, 0.9)"
                          : "rgba(255, 255, 255, 0.9)",
                      transition: "background 0.3s",
                      "&:hover": {
                        background:
                          theme.palette.mode === "dark"
                            ? "rgba(30, 30, 30, 0.95)"
                            : "rgba(255, 255, 255, 0.95)",
                      },
                    }}
                  >
                    {/* Étage 1: Image (optionnel) */}
                    <Box sx={{ height: 200, position: "relative" }}>
                      {project.image ? (
                        <CardMedia
                          component="img"
                          height="200"
                          image={project.image}
                          alt={projectTrans.title}
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderTopLeftRadius: "16px",
                            borderTopRightRadius: "16px",
                          }}
                        />
                      ) : (
                        <Box
                          sx={{
                            width: "100%",
                            height: "100%",
                            borderTopLeftRadius: "16px",
                            borderTopRightRadius: "16px",
                          }}
                        />
                      )}
                    </Box>

                    {/* Étage 2: Contenu textuel et tags */}
                    <CardContent
                      sx={{
                        flexGrow: 1,
                        pt: 3,
                        pb: 2,
                      }}
                    >
                      <Typography
                        gutterBottom
                        variant="h5"
                        component="h3"
                        sx={{ fontWeight: 700 }}
                      >
                        {projectLink ? (
                          <Link
                            href={projectLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              color: "inherit",
                              textDecoration: "none",
                              "&:hover": {
                                textDecoration: "underline",
                              },
                            }}
                          >
                            {projectTrans.title}
                          </Link>
                        ) : (
                          projectTrans.title
                        )}
                      </Typography>

                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ mb: 2 }}
                      >
                        {projectTrans.description}
                      </Typography>

                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {project.technologies.map((tech, index) => (
                          <Chip
                            key={index}
                            label={tech}
                            size="small"
                            onClick={() => handleTagClick(tech)}
                            sx={{
                              cursor: "pointer",
                              backgroundColor:
                                theme.palette.mode === "dark"
                                  ? theme.palette.primary.dark
                                  : theme.palette.primary.light,
                              color: theme.palette.getContrastText(
                                theme.palette.mode === "dark"
                                  ? theme.palette.primary.dark
                                  : theme.palette.primary.light
                              ),
                              "&:hover": {
                                transform: "scale(1.05)",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                backgroundColor: "#1e88e5",
                              },
                            }}
                          />
                        ))}
                      </Box>
                    </CardContent>

                    {/* Étage 3: Boutons */}
                    <CardActions
                      sx={{
                        justifyContent: "flex-end",
                        background: "transparent",
                        p: 2,
                        minHeight: 52,
                      }}
                    >
                      {project.links.demo && (
                        <IconButton
                          href={project.links.demo}
                          target="_blank"
                          aria-label="Live demo"
                          sx={{
                            backgroundColor: theme.palette.background.paper,
                            borderRadius: "12px",
                            boxShadow: 1,
                            "&:hover": {
                              backgroundColor: theme.palette.action.hover,
                            },
                          }}
                        >
                          <Visibility />
                        </IconButton>
                      )}

                      {project.links.code && (
                        <IconButton
                          href={project.links.code}
                          target="_blank"
                          aria-label="View code"
                          sx={{
                            backgroundColor: theme.palette.background.paper,
                            borderRadius: "12px",
                            boxShadow: 1,
                            "&:hover": {
                              backgroundColor: theme.palette.action.hover,
                            },
                          }}
                        >
                          <Code />
                        </IconButton>
                      )}
                    </CardActions>
                  </Card>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>

      {/* Section Compétences */}
      <Box
        sx={{
          py: 10,
          position: "relative",
          overflow: "hidden",
          background: "linear-gradient(45deg, #800367, #020024, #036D87)",
          backgroundSize: "300% 300%",
          animation: "gradientBackground 15s ease infinite",
          "@keyframes gradientBackground": {
            "0%": { backgroundPosition: "0% 50%" },
            "50%": { backgroundPosition: "100% 50%" },
            "100%": { backgroundPosition: "0% 50%" },
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              theme.palette.mode === "dark"
                ? "linear-gradient(180deg,rgba(2, 0, 36, 1) 1%, rgba(30, 30, 30, 0.5) 100%);"
                : "rgba(255, 255, 255, 0.9)",
            zIndex: 1,
          }}
        />

        <Container maxWidth="md" sx={{ position: "relative", zIndex: 2 }}>
          <Typography
            variant="h3"
            component="h2"
            align="center"
            data-aos="fade-up"
            sx={{
              fontWeight: 700,
              mb: 8,
              fontSize: { xs: "2rem", md: "2.5rem" },
              color: theme.palette.text.primary,
            }}
          >
            {t("skills")}
          </Typography>

          <Grid container spacing={4} justifyContent="center">
            {skills.map((skill, index) => (
              <Grid
                item
                xs={6}
                sm={3}
                key={skill.name}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <Box textAlign="center">
                  <Avatar
                    src={skill.icon}
                    alt={skill.name}
                    sx={{
                      width: 80,
                      height: 80,
                      margin: "0 auto",
                      boxShadow: 3,
                      backgroundColor: "background.paper",
                      borderColor: "#ffffff",
                      borderWidth: 4,
                      borderStyle: "solid",
                      transition: "transform 0.3s, box-shadow 0.3s",
                      "&:hover": {
                        transform: "scale(1.1)",
                        boxShadow: 6,
                      },
                    }}
                  />
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mt: 2,
                      fontWeight: 600,
                      color: theme.palette.text.primary,
                    }}
                  >
                    {skill.name}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* GitHub */}
      <FullWidthContent
        title="github_cta_title"
        content="github_cta_description"
        contentAlignment="center"
        ctaText="visit_github"
        ctaLink="https://github.com/GaburaisuVGC"
        ctaTarget="_blank"
        ctaRel="noopener noreferrer"
        backgroundImage="/images/blurred_image.png"
        titleColor="white"
        contentColor="white"
        focusWordKeys={["github", "discover"]}
        focusColor="#42a5f5"
        data-aos="fade-up"
        ctaStyles={{
          backgroundColor: "#42a5f5",
          "&:hover": {
            backgroundColor: "#1e88e5",
          },
        }}
      />

      <Footer />
    </>
  );
}

export default Home;
